"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var breadCrumbs = function (props) {
    var className = props.className, items = props.items;
    var b = config_1.block("breadcrumbs");
    var crumbs = items.map(function (item, index) { return (react_1.default.createElement("li", { key: "crumb_" + index, className: b("item") }, item)); });
    if (!items.length) {
        return null;
    }
    return (react_1.default.createElement("div", { className: b({}).mix(className) },
        react_1.default.createElement("ul", { className: b("nav") }, crumbs)));
};
exports.default = breadCrumbs;
//# sourceMappingURL=index.js.map